/**
 * UserSegmentAggregate -  what is returned from the api as part of the add practice record response.
 */
export default class UserSegmentAggregate {
  userId: number;
  segmentId: number;
  performBestAccuracy?: number;
  performBestStars?: number;
  practiceNewestAccuracy: number;
  practiceBestAccuracy: number;
  practiceProgress: number;
  timePractice: string; // e.g. "140.284"
  timeVideo?: string; // TODO: not sure of type
  timePerform?: string;
  timeTotal: string; // e.g. "149.283"
  timeModified: string; // e.g. "1557772447"
  timeReadOpened: string; // e.g."time_read_opened": "2019-05-02 13:24:16"
  constructor({ userId, segmentId, performBestAccuracy, performBestStars, practiceNewestAccuracy, practiceBestAccuracy, practiceProgress, timePractice, timeVideo, timePerform, timeTotal, timeModified, timeReadOpened, }: UserSegmentAggregate) {
    Object.assign(this, { userId, segmentId, performBestAccuracy, performBestStars, practiceNewestAccuracy, practiceBestAccuracy, practiceProgress, timePractice, timeVideo, timePerform, timeTotal, timeModified, timeReadOpened, });
  }
}